import React from "react";
import { Button, Input } from "reactstrap";

const FooterPagination = ({
  itemsCount,
  onChangePage,
  currentPage,
  totalPages,
  totalItems,
}) => {
  const handleChangePage = (page) => {
    onChangePage(page);
  };

  const handleSelectChange = (event) => {
    const selectedPage = parseInt(event.target.value, 10);
    handleChangePage(selectedPage);
  };

  return (
    <tr>
      <td colSpan="12">
        <div className="d-flex pt-3 mb-n2 justify-content-end align-items-center">
          <div className="d-flex align-items-center justify-content-end">
            {currentPage !== 0 && (
              <Button
                onClick={() => handleChangePage(currentPage - 1)}
                color="soft-primary"
                className="btn btn-sm btn-pills "
                disabled={currentPage === 0}
              >
                <i className="ri-arrow-left-line"></i>
              </Button>
            )}
            <span className="mx-2">
              Page{" "}
              <Input
                type="select"
                value={currentPage}
                className="py-1"
                onChange={handleSelectChange}
                style={{
                  display: "inline-block",
                  width: "auto",
                }}
              >
                {Array.from({ length: totalPages }, (_, index) => (
                  <option key={index} value={index}>
                    {index + 1}
                  </option>
                ))}
              </Input>{" "}
              of {totalPages}
            </span>
            {currentPage !== totalPages - 1 && (
              <Button
                disabled={currentPage === totalPages - 1}
                onClick={() => handleChangePage(currentPage + 1)}
                color="soft-primary"
                className="btn btn-sm btn-pills me-1"
              >
                <i className="ri-arrow-right-line"></i>
              </Button>
            )}
          </div>
        </div>
      </td>
    </tr>
  );
};

export default FooterPagination;
